export default __webpack_public_path__ + "static/media/icon-info-extended.f2b2bf6f.svg";